import OrgAutomations from './OrgAutomations';

export default function Automations() {
  // Google Review is now a standalone section for everyone — super admin and orgs alike.
  // OrgAutomations is role-aware: super admin uses Rostery's global endpoints, orgs use /my-*.
  return <OrgAutomations />;
}
